import { CellProps } from 'react-table'
import { formatDateTime } from '../../../../../../../_metronic/helpers/crud-helper/helpers'
import { StackedCell } from '../../../../../../components/Table/TableCells'
import { PlainHeader } from '../../../../../../components/Table/SortableHeader'
import { TableColumn } from '../../../../../../components/Table/tableTypes'
import { ProtocoloLinha } from '../../../core/_models'
import { SituacaoProtocoloBadge } from '../../../components/SituacaoProtocoloBadge'
import { aprovadoPor, origemDaVersao } from '../../core/_formato'
import { ProtocoloAcoesCell } from './ProtocoloAcoesCell'

type Config = {
  idEmpresa?: number
  podeCriarRascunho: boolean
}

// O endpoint devolve a lista inteira, sem ordenação no servidor: cabeçalhos sem ordenação.
export const protocolosColumns = ({
  idEmpresa,
  podeCriarRascunho,
}: Config): ReadonlyArray<TableColumn<ProtocoloLinha>> => [
  {
    Header: () => <PlainHeader>Versão / Nome</PlainHeader>,
    id: 'versao',
    Cell: ({ row }: CellProps<ProtocoloLinha>) => (
      <StackedCell primary={`Versão ${row.original.versao}`} secondary={row.original.nome} />
    ),
  },
  {
    Header: () => <PlainHeader>Situação</PlainHeader>,
    id: 'situacao',
    cellWidth: '140px',
    Cell: ({ row }: CellProps<ProtocoloLinha>) => (
      <SituacaoProtocoloBadge situacao={row.original.situacao} />
    ),
  },
  {
    Header: () => <PlainHeader>Formulário / Origem</PlainHeader>,
    id: 'formulario',
    // Larguras fixas aqui e em "Criado / Aprovado": a sobra vai para "Versão / Nome".
    cellWidth: '240px',
    Cell: ({ row }: CellProps<ProtocoloLinha>) => (
      <StackedCell
        primary={row.original.formulario?.nome}
        secondary={origemDaVersao(row.original)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>Criado / Aprovado</PlainHeader>,
    id: 'autoria',
    cellWidth: '260px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ProtocoloLinha>) => {
      const aprovacao = aprovadoPor(row.original)
      return (
        <StackedCell
          primary={
            [row.original.criadoPor, formatDateTime(row.original.dataInclusao)]
              .filter(Boolean)
              .join(' em ') || undefined
          }
          secondary={aprovacao ? `Aprovado por ${aprovacao}` : undefined}
        />
      )
    },
  },
  {
    Header: () => <PlainHeader>Vigência</PlainHeader>,
    id: 'vigencia',
    cellWidth: '180px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ProtocoloLinha>) => {
      const { dtInicioVigencia, dtFimVigencia } = row.original
      return (
        <StackedCell
          tabular
          primary={dtInicioVigencia ? formatDateTime(dtInicioVigencia) : undefined}
          secondary={
            dtInicioVigencia
              ? dtFimVigencia
                ? `até ${formatDateTime(dtFimVigencia)}`
                : 'até agora'
              : undefined
          }
        />
      )
    },
  },
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '100px',
    align: 'end',
    Cell: ({ row }: CellProps<ProtocoloLinha>) => (
      <ProtocoloAcoesCell
        versao={row.original}
        idEmpresa={idEmpresa}
        podeCriarRascunho={podeCriarRascunho}
      />
    ),
  },
]
